import React from 'react';
import PropTypes from 'prop-types';

import TextField from './text_field';

const PhoneFormat = /^\d{10,}$/;

class PhoneField extends TextField {
  constructor(props) {
    super(props);

    const startingValue = this.props.value || '';

    this.state = Object.assign(this.state, {
      rawValue: startingValue,
    });

    this.validations.push(this.validatePhoneFormat);
  }

  newStateFromInput(e) {
    return {
      rawValue: e.target.value,
      value: e.target.value.replace(/\D/g,'')
    }
  }

  validatePhoneFormat(value) {
    if (!PhoneFormat.test(value)) {
      return 'Phone is formatted incorrectly';
    }
  }

  renderInput() {
    return (
      <input type='tel'
        name={ this.props.name }
        placeholder={ this.props.displayName }
        onChange={ this.handleChange }
        onBlur={ this.handleBlur }
        value={ this.state.rawValue }
        className={ this.state.shouldDisplayError ? 'errored-field' : '' }
        disabled={ this.props.disabled }
      />
    );
  }
}

PhoneField.propTypes = {
  updateModel: PropTypes.func.isRequired,
  updateErrorMessage: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onValid: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  value: PropTypes.string,
  className: PropTypes.string,
  displayName: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

export default PhoneField;
